import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-switch-field",
  "use": "icon-switch-field-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-switch-field\"><defs><style type=\"text/css\"></style></defs><path d=\"M692 792H332C182 792 62 672 62 522s120-270 270-270h360c150 0 270 120 270 270 0 147-120 270-270 270zM332 312c-117 0-210 93-210 210s93 210 210 210h360c117 0 210-93 210-210s-93-210-210-210H332z\" p-id=\"48564\" /><path d=\"M191 522a150 150 0 1 0 300 0 150 150 0 1 0-300 0z\" p-id=\"48565\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol